import styled from '@emotion/styled';

import {SizeTokenValue} from 'common';
import {CloseIcon} from 'icons';
import {ButtonVariant, IconButton} from 'Button';

import type {BannerProps} from '../types';

const Container = styled.div<Pick<BannerProps, 'size'>>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  ${props => {
    let size = 24;

    switch (props.size) {
      case SizeTokenValue.XSmall:
      case SizeTokenValue.XXSmall:
        size = 16;
        break;
    }

    return {width: size, height: size};
  }}
`;

export const CloseButton: React.FC<Pick<BannerProps, 'onClose' | 'size' | 'qa'>> = ({onClose, size, qa}) => {
  if (!onClose) {
    return null;
  }

  return (
    <Container size={size}>
      <IconButton qa={`${qa}-close`} size={SizeTokenValue.XXSmall} variant={ButtonVariant.InnerInput} onClick={onClose}>
        <CloseIcon size={SizeTokenValue.Small} />
      </IconButton>
    </Container>
  );
};
